import { z } from 'zod';

export const contactPersonSchema = z.object({
  name: z.string().nonempty(),
  position: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
});

export const FormSchema = z.object({
  partner_number: z.string().nonempty(),
  user_id: z.string().nonempty(),
  company_type: z.string().nonempty(),
  name: z.string().nonempty(),
  email: z.string().nullable().optional(),
  phone: z.string().nonempty(),
  contact_persons: z.array(contactPersonSchema),
});
